// Anonymous function to avoid polluting the global scope
(function () {
  // Select relevant elements from the DOM
  const tabbed = document.querySelectorAll(".tabs-to-accordion");
  const panels = document.querySelectorAll(".tab__content");
  const tabLinks = document.querySelectorAll(".tab__link");
  const accordions = document.querySelectorAll(".accordion__trigger");

  /**
   * Retrieve a query parameter value from the URL.
   * @param {string} queryVariable - Query parameter to search for.
   * @returns {string|boolean} - Value of the parameter or false if not found.
   */
  const getQueryValue = (queryVariable) => {
    const query = window.location.search.substring(1).split("&");
    for (const pair of query) {
      const [key, value] = pair.split("=");
      if (key === queryVariable) {
        return value;
      }
    }
    return false;
  };

  /**
   * Format a tab title to match the expected URL structure.
   * @param {string} title - Tab title to sanitize.
   * @returns {string} - Sanitized tab title.
   */
  const sanitizeTabTitle = (title) => title
    .trim()
    .replace(/&|%20%20| {2}|--|%20| /g, "-")
    .toLowerCase();

  /**
   * Switch tabs while updating accessibility and visibility.
   * @param {HTMLElement} oldTab - Previously active tab.
   * @param {HTMLElement} newTab - Tab to activate.
   */
  const switchTab = (oldTab, newTab) => {
    newTab.focus();
    newTab.setAttribute("aria-selected", "true");
    newTab.removeAttribute("tabindex");

    oldTab.removeAttribute("aria-selected");
    oldTab.setAttribute("tabindex", "-1");

    const oldIndex = [...tabLinks].indexOf(oldTab);
    const newIndex = [...tabLinks].indexOf(newTab);

    panels[oldIndex].classList.remove("tab__content--visible");
    panels[oldIndex].setAttribute("aria-hidden", "true");

    panels[newIndex].classList.add("tab__content--visible");
    panels[newIndex].setAttribute("aria-hidden", "false");
  };

  // Attach accordion behavior
  accordions.forEach((accordion) => {
    accordion.addEventListener("click", (e) => {
      e.preventDefault();

      const parent = accordion.closest(".tab-group");
      const isExpanded = accordion.getAttribute("aria-expanded") === "true";

      parent.querySelectorAll(".accordion__trigger").forEach((trigger) => {
        trigger.setAttribute("aria-expanded", "false");
        trigger.nextElementSibling.setAttribute("aria-hidden", "true");
      });

      if (!isExpanded) {
        accordion.setAttribute("aria-expanded", "true");
        accordion.nextElementSibling.setAttribute("aria-hidden", "false");

        if (parent.hasAttribute("data-persist-tabs")) {
          const activeTabQuery = sanitizeTabTitle(accordion.textContent);
          const url = new URL(window.location);
          url.searchParams.set("active_tab", activeTabQuery);
          window.history.pushState({}, "", url);

          const paginationLinks = parent.querySelectorAll(".pager__items a");
          paginationLinks.forEach((link) => {
            const updatedURL = new URL(link.href);
            updatedURL.searchParams.set("active_tab", activeTabQuery);
            link.href = updatedURL.toString();
          });
        }
      }
    });
  });

  // Attach tab functionality
  tabbed.forEach((group) => {
    const tabs = group.querySelectorAll(".tab__link");

    tabs.forEach((tab, index) => {
      // Click handling
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        const currentTab = group.querySelector("[aria-selected]");
        if (tab !== currentTab) {
          switchTab(currentTab, tab);

          if (group.hasAttribute("data-persist-tabs")) {
            const activeTabQuery = sanitizeTabTitle(tab.textContent);
            const url = new URL(window.location);
            url.searchParams.set("active_tab", activeTabQuery);
            window.history.pushState({}, "", url);
          }
        }
      });

      // Keyboard navigation handling
      tab.addEventListener("keydown", (e) => {
        const dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : null;
        if (dir !== null && tabs[dir]) {
          e.preventDefault();
          switchTab(tab, tabs[dir]);
        }
      });
    });
  });

  /**
   * Resize logic to maintain state based on the active tab query parameter.
   */
  const resizeTabsAndAccordions = () => {
    const activeTab = getQueryValue("active_tab");
    if (!activeTab) return;

    const tabPanel = document.querySelector(`#tab-panel-${activeTab}`);
    const activeTabLink = document.querySelector(
      `.tab__link[aria-controls=tab-panel-${activeTab}]`
    );
    const activeAccordion = document.querySelector(
      `.accordion__trigger[aria-controls=tab-panel-${activeTab}]`
    );

    if (tabPanel) {
      panels.forEach((panel) => {
        panel.classList.remove("tab__content--visible");
        panel.setAttribute("aria-hidden", "true");
      });
      tabPanel.classList.add("tab__content--visible");
      tabPanel.setAttribute("aria-hidden", "false");
    }

    if (activeTabLink) {
      tabLinks.forEach((link) => {
        link.removeAttribute("aria-selected");
        link.setAttribute("tabindex", "-1");
      });
      activeTabLink.setAttribute("aria-selected", "true");
      activeTabLink.removeAttribute("tabindex");
    }

    if (activeAccordion) {
      accordions.forEach((acc) => {
        acc.setAttribute("aria-expanded", "false");
      });
      activeAccordion.setAttribute("aria-expanded", "true");
    }
  };

  // Recalculate tabs/accordions on resize
  window.addEventListener("resize", resizeTabsAndAccordions);
})();
